export class Lives {
  static readonly MAX = 4;
  private count = Lives.MAX;

  decrement(): void {
    if (this.count > 0) this.count -= 1;
  }

  reset(): void {
    this.count = Lives.MAX;
  }

  get remaining(): number {
    return this.count;
  }

  get exhausted(): boolean {
    return this.count === 0;
  }
}
